import { useState } from "react";
import { BellRing } from "lucide-react";
import api, { formatApiErrorDetail } from "@/lib/api";
import { EmailAlertDialog } from "@/components/EmailAlertDialog";
import { cn } from "@/lib/utils";
import { toast } from "sonner";

export function NewLotsButton({ className, label = "New Lots" }) {
  const [open, setOpen] = useState(false);

  const submit = async (email) => {
    try {
      const { data } = await api.post("/alerts/lots", { email });
      toast.success(data.message || "You'll be notified about new lots");
      setOpen(false);
    } catch (e) {
      toast.error(formatApiErrorDetail(e.response?.data?.detail));
    }
  };

  return (
    <>
      <button
        data-testid="new-lots-button"
        onClick={() => setOpen(true)}
        className={cn("flex items-center gap-2 bg-discount text-ink px-4 h-10 font-mono text-xs uppercase tracking-[0.15em] border border-ink hover:bg-ink hover:text-paper transition-colors", className)}
      >
        <BellRing className="h-4 w-4" /> {label}
      </button>
      <EmailAlertDialog
        open={open}
        onOpenChange={setOpen}
        title="New Lot Alerts"
        description="Be the first to know when we upload a fresh auction lot. We'll email you the moment new lot inventory goes live."
        cta="Notify Me Of New Lots"
        onSubmit={submit}
      />
    </>
  );
}
